import React from 'react'
import PropTypes from 'prop-types';
import LineTitle from '../LineTitle';
import ProductCard from '../ProductCard';
import QuoteInfo from '../QuoteInfo/';
import LightList from '../aelComponent/LightList/';
import './index.scss';

const Discount = props => {
  const {
    discounts,
    style,
    toAppPage
  } = props;
  return (
    <div className='discountsBox'>
      {
        discounts.title ? <LineTitle title={discounts.title} style={style}></LineTitle> : null
      }
      {
        discounts.contents && discounts.contents.map((item, index) => {
          let textMod
          if (item.quote) {
            textMod = <QuoteInfo data={item.text}></QuoteInfo>
          } else if (item.highlight) {
            textMod = <LightList data={item.text}></LightList>
          } else {
            textMod = <article className='ordinaryText' data-type='discountQuoteInfo'>{item.text}</article>
          }

          return (
            <div className='discountItem' key={index + '_contentBox'}>
              <div className='ordinaryTitle'>{item.code}</div>
              {textMod}
              <ProductCard
                img={item.image}
                btn={item.imageButton || {}}
                imageText={item.imageText}
              ></ProductCard>
              {
                item.link && <div className='discountLabel' onClick={() => toAppPage(item.link)}>
                  {item.label}
                </div>
              }
            </div>
          )
        })
      }
    </div >
  )
}

Discount.propTypes = {
  data: PropTypes.object,
  style: PropTypes.object
}

export default Discount